import { VAT } from "../constants/actionTypes";

const Prices = (price, count, length, urgent, addson, urgentFee) => {
  const subtotal =
    (price + (urgent ? urgentFee : 0)) * count * length +
    addson?.apostilles +
    addson?.certified +
    addson?.notarization +
    addson?.sworn;
  const vat = (subtotal * VAT) / 100;
  const total = subtotal + vat;
  return { subtotal, vat, total };
};

export default Prices;
